import type { PayloadAction } from '@reduxjs/toolkit'
import { createSlice } from '@reduxjs/toolkit'

import { Card } from '../components/Kanban/interfaces/kanban'

interface CartaReservaModalState {
  isOpenCartaReservaModal: boolean
  bookingCards: Card[]
}

const initialState: CartaReservaModalState = {
  isOpenCartaReservaModal: false,
  bookingCards: [],
}

const cartaReservaModalSlice = createSlice({
  name: 'cartaReservaModal',
  initialState,
  reducers: {
    setIsOpenCartaReservaModal(state, action: PayloadAction<{ value: boolean }>) {
      state.isOpenCartaReservaModal = action.payload.value
    },
    setBookingCardsReservaModal(state, action: PayloadAction<{ value: Card[] }>) {
      state.bookingCards = action.payload.value
    },
  },
})

export const { setIsOpenCartaReservaModal, setBookingCardsReservaModal } =
  cartaReservaModalSlice.actions

const CartaReservaModalReducer = cartaReservaModalSlice.reducer

export default CartaReservaModalReducer
